import React from 'react'

import './Panels.css'

export type Props = {
  children: React.ReactNode
}

function PanelBody(props: Props) {
  return (
      <div className="panel-body">
        {props.children}
      </div>
  )
}

export default PanelBody
